import React from 'react';
import PropTypes from 'prop-types';

const HintBlock = ({ children, success, error, className }) => {
  return (
    <div
      className={`${
        error
          ? 'bg-red-200 text-red-700'
          : success
          ? 'bg-green-100 text-green-800'
          : 'bg-blue-100 text-black'
      } p-4 ${className}`}
    >
      {children}
    </div>
  );
};

HintBlock.propTypes = {
  children: PropTypes.node,
  success: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

export default HintBlock;
